module.exports = __webpack_public_path__ + "img/architecturalart_bodyimage02_jp.fdac7228.png";